import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.policy.recommendation');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { RegionNode, RegionSelectionService } from 'src/app/region-selection.service';
import { PolicySimulationStateService } from 'src/app/policy-simulation-state.service';

@Component({
    selector: 'wiz-page-policy-recommendation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.policy.recommendation/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f4f6f8;
}

.recommendation-panel,
.recommendation-empty,
.recommendation-selection-bar {
  border: 1px solid #d7dde5;
  border-radius: 6px;
  background: #fff;
}

.recommendation-input-panel {
  padding: 16px;
}

.recommendation-input-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.recommendation-input-panel label span {
  display: block;
  margin-bottom: 6px;
  color: #66717f;
  font-size: 10px;
  font-weight: 800;
}

.recommendation-input-panel select,
.recommendation-input-panel input {
  width: 100%;
  min-height: 39px;
  border: 1px solid #cfd6df;
  border-radius: 4px;
  background: #fff;
  padding: 0 10px;
  color: #172231;
  font-size: 12px;
}

.recommendation-weight-row {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr)) auto;
  gap: 12px;
  align-items: end;
  margin-top: 14px;
  border-top: 1px solid #e5e8ec;
  padding-top: 14px;
}

.recommendation-input-panel button,
.recommendation-empty button,
.recommendation-page-actions button {
  min-height: 39px;
  border: 0;
  border-radius: 4px;
  background: #2b5d87;
  padding: 0 16px;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
}

.recommendation-input-panel button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.recommendation-empty .is-secondary,
.recommendation-page-actions .is-secondary {
  border: 1px solid #cfd6df;
  background: #fff;
  color: #334155;
}

.recommendation-loading,
.recommendation-empty {
  padding: 42px 20px;
  text-align: center;
  color: #66717f;
  font-size: 12px;
}

.recommendation-empty strong {
  display: block;
  color: #172231;
  font-size: 14px;
}

.recommendation-empty p {
  margin-top: 6px;
}

.recommendation-empty div {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
}

.recommendation-alert {
  border-radius: 5px;
  padding: 12px 14px;
  font-size: 11px;
}

.recommendation-alert--error {
  border: 1px solid #f3b6ba;
  background: #fff1f1;
  color: #a61b27;
}

.recommendation-selection-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 20px;
  color: #172231;
  font-size: 14px;
}

.recommendation-selection-bar small {
  display: block;
  margin-top: 5px;
  color: #66717f;
  font-size: 10px;
  font-weight: 500;
}

.recommendation-status {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.recommendation-status.is-ready {
  background: #e7f5ec;
  color: #237447;
}

.recommendation-status.is-held {
  background: #fff2dc;
  color: #a15c0a;
}

.recommendation-status.is-error {
  background: #feecec;
  color: #b4232c;
}

.recommendation-status.is-neutral {
  background: #edf0f3;
  color: #657181;
}

.policy-state-signals {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.policy-state-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 28px;
  border: 1px solid currentColor;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 800;
  white-space: normal;
}

.policy-state-chip.is-success {
  background: #e7f5ec;
  color: #237447;
}

.policy-state-chip.is-pending {
  background: #fff2dc;
  color: #8a4f08;
}

.policy-state-chip.is-blocked {
  background: #eef2f6;
  color: #475569;
}

.policy-state-chip.is-warning {
  background: #fff4e5;
  color: #9a4d00;
}

.policy-state-chip.is-info {
  background: #edf5fb;
  color: #255d85;
}

.policy-state-chip.is-scope {
  background: #f1f5f9;
  color: #526171;
}

.policy-status-legend {
  padding: 16px 20px;
}

.policy-status-legend summary {
  cursor: pointer;
  color: #2b5d87;
  font-size: 11px;
  font-weight: 800;
}

.policy-status-legend__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.policy-status-legend__grid article {
  min-width: 0;
  border: 1px solid #e2e6eb;
  border-radius: 5px;
  padding: 10px;
}

.policy-status-legend__grid code {
  display: block;
  margin-top: 7px;
  overflow-wrap: anywhere;
  color: #334155;
  font-size: 9px;
}

.policy-status-legend__grid p {
  margin-top: 5px;
  color: #66717f;
  font-size: 9px;
  line-height: 1.5;
}

.recommendation-result-layout {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(280px, 0.85fr);
  gap: 18px;
}

.recommendation-ranking {
  overflow: hidden;
}

.recommendation-ranking > header,
.recommendation-held > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 22px;
  border-bottom: 1px solid #e2e6eb;
}

.recommendation-ranking h2,
.recommendation-evidence h2,
.recommendation-limitations h2,
.recommendation-held h2 {
  color: #172231;
  font-size: 15px;
  font-weight: 800;
}

.recommendation-ranking header span {
  color: #2b5d87;
  font-size: 11px;
  font-weight: 800;
}

.recommendation-table-wrap {
  overflow-x: auto;
}

.recommendation-ranking table {
  width: 100%;
  min-width: 920px;
  border-collapse: collapse;
  color: #334155;
  font-size: 11px;
}

.recommendation-ranking th {
  background: #f7f8fa;
  color: #66717f;
  font-size: 10px;
  text-align: left;
}

.recommendation-ranking th,
.recommendation-ranking td {
  padding: 12px;
  border-bottom: 1px solid #e5e8ec;
  vertical-align: top;
}

.recommendation-ranking td:nth-child(1) {
  color: #172231;
  font-weight: 800;
}

.recommendation-ranking td:nth-child(2) {
  min-width: 180px;
}

.recommendation-ranking td:last-child {
  min-width: 220px;
  line-height: 1.55;
}

.recommendation-score {
  color: #2b5d87;
  font-weight: 800;
}

.recommendation-basis {
  margin: 16px 20px 20px;
  border: 1px solid #d7dde5;
  border-radius: 5px;
}

.recommendation-basis summary {
  cursor: pointer;
  padding: 12px 14px;
  color: #2b5d87;
  font-size: 11px;
  font-weight: 800;
}

.recommendation-component-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1px;
  border-top: 1px solid #d7dde5;
  background: #d7dde5;
}

.recommendation-component-grid article {
  background: #f8fafc;
  padding: 12px;
}

.recommendation-component-grid span,
.recommendation-component-grid small {
  display: block;
  color: #66717f;
  font-size: 9px;
}

.recommendation-component-grid strong {
  display: block;
  margin: 5px 0;
  color: #172231;
  font-size: 15px;
}

.recommendation-evidence {
  padding: 20px;
}

.recommendation-evidence dl {
  margin-top: 12px;
}

.recommendation-evidence dl div {
  border-bottom: 1px solid #e2e6eb;
  padding: 10px 0;
}

.recommendation-evidence dt {
  color: #66717f;
  font-size: 10px;
}

.recommendation-evidence dd {
  margin-top: 4px;
  overflow-wrap: anywhere;
  color: #172231;
  font-size: 12px;
  font-weight: 800;
}

.recommendation-reason {
  margin-top: 18px;
  border-radius: 5px;
  background: #edf3f8;
  padding: 13px;
  color: #38536c;
  font-size: 10px;
  line-height: 1.6;
}

.recommendation-held {
  overflow: hidden;
}

.recommendation-held header p {
  color: #a15c0a;
  font-size: 10px;
  font-weight: 800;
}

.recommendation-held header h2 {
  margin-top: 5px;
}

.recommendation-held__detail {
  margin: 18px 22px;
  border-left: 3px solid #d98a25;
  padding-left: 12px;
  color: #74470d;
  font-size: 11px;
  line-height: 1.65;
}

.recommendation-hold-facts {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  border-top: 1px solid #e2e6eb;
  border-bottom: 1px solid #e2e6eb;
}

.recommendation-hold-facts div {
  padding: 14px 18px;
  border-right: 1px solid #e2e6eb;
}

.recommendation-hold-facts div:last-child {
  border-right: 0;
}

.recommendation-hold-facts dt {
  color: #66717f;
  font-size: 9px;
}

.recommendation-hold-facts dd {
  margin-top: 5px;
  overflow-wrap: anywhere;
  color: #172231;
  font-size: 11px;
  font-weight: 800;
}

.recommendation-alternatives {
  padding: 18px 22px;
}

.recommendation-alternatives h3 {
  color: #172231;
  font-size: 12px;
  font-weight: 800;
}

.recommendation-alternatives ul {
  display: grid;
  gap: 8px;
  margin-top: 10px;
}

.recommendation-alternatives li {
  border-radius: 4px;
  background: #f7f8fa;
  padding: 10px 12px;
  color: #66717f;
  font-size: 10px;
}

.recommendation-alternatives strong {
  display: block;
  color: #2b5d87;
}

.recommendation-alternatives span {
  display: block;
  margin-top: 3px;
}

.recommendation-limitations {
  padding: 18px 22px;
}

.recommendation-limitations ul {
  display: grid;
  gap: 4px;
  margin-top: 10px;
  color: #66717f;
  font-size: 10px;
  line-height: 1.55;
}

.recommendation-limitations p {
  margin-top: 12px;
  border-top: 1px solid #e2e6eb;
  padding-top: 12px;
  color: #2b5d87;
  font-size: 10px;
  font-weight: 800;
}

.recommendation-page-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@media (max-width: 1050px) {
  .recommendation-input-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .recommendation-weight-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .recommendation-result-layout {
    grid-template-columns: 1fr;
  }
  .recommendation-hold-facts {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .recommendation-input-grid,
  .recommendation-weight-row {
    grid-template-columns: 1fr;
  }
  .recommendation-selection-bar,
  .recommendation-held > header {
    align-items: flex-start;
    flex-direction: column;
  }
  .recommendation-component-grid {
    grid-template-columns: 1fr;
  }
  .recommendation-hold-facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .recommendation-page-actions {
    flex-direction: column;
  }
  .policy-status-legend__grid {
    grid-template-columns: 1fr;
  }
  .recommendation-input-panel button,
  .recommendation-empty button,
  .recommendation-page-actions button {
    min-height: 44px;
  }
}`],
})
export class PagePolicyRecommendationComponent implements OnInit {
    public config: any = {
        meta: null,
        region_tree: { regions: [] },
        industries: [],
        goals: [],
        default_goal_key: 'GROWTH_PROMOTION',
        default_weights: {},
    };
    public selectedMetropolitanId: string = '';
    public selectedBasicId: string = '';
    public selectedIndustryCode: string = '';
    public selectedGoalKey: string = 'GROWTH_PROMOTION';
    public weights: any = {
        specialization: 3,
        employment: 3,
        growth: 3,
        urgency: 3,
        feasibility: 3,
    };
    public result: any = null;
    public loading: boolean = true;
    public recommending: boolean = false;
    public errorMessage: string = '';
    private requestedParentRegionId: string = '';
    private shouldRestoreResult: boolean = false;

    constructor(@Inject( Service)         public service: Service,@Inject( RegionSelectionService)         public regionSelection: RegionSelectionService,@Inject( PolicySimulationStateService)         public policyState: PolicySimulationStateService,@Inject( Router)         private router: Router,    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.regionSelection.loadTree();
        await this.loadConfig();
        this.restoreInputs();
        this.loading = false;
        await this.service.render();
        if (this.shouldRestoreResult && this.canRecommend) {
            await this.runRecommendation();
        }
    }

    public get metropolitanRegions(): RegionNode[] {
        return this.config?.region_tree?.regions || [];
    }

    public get basicRegions(): RegionNode[] {
        const parent = this.metropolitanRegions.find(item => item.region_id === this.selectedMetropolitanId);
        return parent?.children || [];
    }

    public get selection() {
        return this.regionSelection.selection;
    }

    public get canRecommend(): boolean {
        return !!this.selection?.region_id
            && this.selection.analysis_status === 'READY'
            && !!this.selectedIndustryCode
            && !!this.selectedGoalKey
            && this.validWeights();
    }

    public publicResultAvailable(): boolean {
        const status = this.result?.status;
        return status?.policy_ready === true
            && ['POLICY_READY', 'RECOMMENDATION_AVAILABLE'].includes(status.primary_status || status.code)
            && (!Array.isArray(status.blocking_reasons) || status.blocking_reasons.length === 0)
            && Array.isArray(this.result?.recommendations)
            && this.result.recommendations.length > 0;
    }

    public focusIndustrySelector() {
        document.getElementById('recommendation-industry-select')?.focus();
    }

    public async changeMetropolitan(event: any) {
        this.selectedMetropolitanId = event?.target?.value || '';
        this.selectedBasicId = '';
        this.requestedParentRegionId = '';
        this.resetResult();
        if (!this.selectedMetropolitanId) this.regionSelection.clear();
        else this.regionSelection.selectByRef(this.selectedMetropolitanId);
        await this.service.render();
    }

    public async changeBasic(event: any) {
        this.selectedBasicId = event?.target?.value || '';
        this.resetResult();
        const regionId = this.selectedBasicId || this.selectedMetropolitanId;
        if (regionId) this.regionSelection.selectByRef(regionId);
        this.requestedParentRegionId = this.regionSelection.selection?.parent_region_id || '';
        await this.service.render();
    }

    public async changeIndustry(event: any) {
        this.selectedIndustryCode = event?.target?.value || '';
        this.resetResult();
        await this.service.render();
    }

    public async changeGoal(event: any) {
        this.selectedGoalKey = event?.target?.value || this.config.default_goal_key;
        this.resetResult();
        await this.service.render();
    }

    public async changeWeight(key: string, event: any) {
        this.weights[key] = Number(event?.target?.value);
        this.resetResult();
        await this.service.render();
    }

    public async runRecommendation() {
        if (!this.canRecommend) return;
        this.recommending = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('recommend', {
                region_id: this.selection.region_id,
                parent_region_id: this.requestedParentRegionId || this.selection.parent_region_id || '',
                industry_code: this.selectedIndustryCode,
                reference_year: this.referenceYear,
                goal_key: this.selectedGoalKey,
                weight_specialization: this.weights.specialization,
                weight_employment: this.weights.employment,
                weight_growth: this.weights.growth,
                weight_urgency: this.weights.urgency,
                weight_feasibility: this.weights.feasibility,
            });
            if (
                code !== 200
                || !data?.selection
                || !data?.status
                || !Array.isArray(data?.recommendations)
            ) {
                throw new Error(data?.message || '정책 추천 결과의 필수 필드를 확인하지 못했습니다.');
            }
            this.result = data;
            this.persistInputs();
        } catch (error) {
            this.result = null;
            this.errorMessage = error?.message || '정책 추천 결과를 불러오지 못했습니다.';
        } finally {
            this.recommending = false;
            await this.service.render();
        }
    }

    public openSimulator() {
        this.persistInputs();
        void this.router.navigate(['/policy-simulator']);
    }

    public openRegionalAnalysis() {
        this.persistInputs();
        void this.router.navigate(['/regional-analysis']);
    }

    public formatCount(value: number | null | undefined): string {
        return value === null || value === undefined ? '-' : Number(value).toLocaleString('ko-KR');
    }

    public formatLq(value: number | null | undefined): string {
        return value === null || value === undefined ? '-' : Number(value).toFixed(2);
    }

    public formatGrowth(value: number | null | undefined): string {
        if (value === null || value === undefined) return '검증 대기';
        const numeric = Number(value);
        return `${numeric > 0 ? '+' : ''}${numeric.toFixed(2)}%`;
    }

    public formatScore(value: number | null | undefined): string {
        return value === null || value === undefined ? '-' : Number(value).toFixed(1);
    }

    public formatWeight(value: number | null | undefined): string {
        return value === null || value === undefined ? '-' : `${(Number(value) * 100).toFixed(1)}%`;
    }

    public join(values: string[] | null | undefined): string {
        return values?.length ? values.join(' · ') : '-';
    }

    public statusClass(): string {
        if (!this.result) return 'is-neutral';
        if (!this.result.status?.lq_ready) return 'is-error';
        return this.result.status?.policy_ready ? 'is-ready' : 'is-held';
    }

    public statusLegend(): any[] {
        const statuses = this.config?.policy_status_registry?.statuses || {};
        return Object.keys(statuses).map(code => ({ code, ...statuses[code] }));
    }

    private get referenceYear(): number | null {
        return this.config.meta?.reference_year || this.config.meta?.year || null;
    }

    private async loadConfig() {
        try {
            const { code, data } = await wiz.call('config', {
                reference_year: this.regionSelection.referenceYear,
            });
            if (
                code !== 200
                || !data?.region_tree
                || !Array.isArray(data?.industries)
                || !Array.isArray(data?.goals)
            ) {
                throw new Error(data?.message || '정책 추천 설정의 필수 필드를 확인하지 못했습니다.');
            }
            this.config = data;
            this.selectedGoalKey = data.default_goal_key || 'GROWTH_PROMOTION';
            this.weights = { ...data.default_weights };
        } catch (error) {
            this.errorMessage = error?.message || '정책 추천 설정을 불러오지 못했습니다.';
        }
    }

    private restoreInputs() {
        const query = new URLSearchParams(window.location.search);
        const stored = this.policyState.read();
        const hasQuerySelection = query.has('region_id') || query.has('industry_code');
        const stateInput = stored?.input || null;
        const regionId = query.has('region_id')
            ? (query.get('region_id') || '')
            : (stateInput?.region_id || this.regionSelection.selection?.region_id || '');
        const industryCode = query.has('industry_code')
            ? (query.get('industry_code') || '')
            : (stateInput?.industry_code || '');
        const goalKey = query.has('policy_goal') || query.has('goal_key')
            ? (query.get('policy_goal') || query.get('goal_key') || '')
            : (stateInput?.goal_key || this.config.default_goal_key);
        const node = regionId ? this.regionSelection.resolve(regionId) : null;
        if (node?.analysis_status === 'READY') {
            this.regionSelection.select(node);
        } else if (hasQuerySelection) {
            this.regionSelection.clear();
            if (node) this.regionSelection.block(node);
        }
        const selection = this.regionSelection.selection;
        if (selection?.region_type === 'METROPOLITAN') {
            this.selectedMetropolitanId = selection.region_id;
            this.selectedBasicId = '';
        } else if (selection?.region_type === 'BASIC') {
            this.selectedMetropolitanId = selection.parent_region_id || '';
            this.selectedBasicId = selection.region_id;
        }
        this.requestedParentRegionId = query.has('parent_region_id')
            ? (query.get('parent_region_id') || '')
            : (stateInput?.parent_region_id || selection?.parent_region_id || '');
        if (this.config.industries.some((item: any) => item.code === industryCode)) {
            this.selectedIndustryCode = industryCode;
        }
        if (this.config.goals.some((item: any) => item.key === goalKey)) {
            this.selectedGoalKey = goalKey;
        }
        Object.keys(this.weights).forEach(key => {
            const queryKey = `weight_${key}`;
            const value = query.has(queryKey)
                ? Number(query.get(queryKey))
                : Number(stateInput?.weights?.[key]);
            if (Number.isInteger(value) && value >= 1 && value <= 5) this.weights[key] = value;
        });
        this.shouldRestoreResult = !!selection
            && !!this.selectedIndustryCode
            && (hasQuerySelection || !!stateInput);
    }

    private persistInputs() {
        if (!this.selection) return;
        const industry = this.config.industries.find((item: any) => item.code === this.selectedIndustryCode);
        this.policyState.save(this.selection, {
            region_id: this.selection.region_id,
            region_name: this.selection.region_name,
            region_type: this.selection.region_type,
            parent_region_id: this.selection.parent_region_id,
            industry_code: this.selectedIndustryCode,
            industry_name: industry?.name || '',
            goal_key: this.selectedGoalKey,
            policy_goal: this.selectedGoalKey,
            weights: { ...this.weights },
            data_year: this.referenceYear,
        }, null);
    }

    private validWeights(): boolean {
        return Object.values(this.weights).every((value: any) =>
            Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 5
        );
    }

    private resetResult() {
        this.result = null;
        this.errorMessage = '';
    }
}

export default PagePolicyRecommendationComponent;